import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { RouterView } from "vue-router";
import Headers from "@/components/header/index.vue";
import Footers from "@/components/footer/index.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(Headers, {
        class: "headers"
      }), _createVNode(_unref(RouterView)), _createVNode(Footers)], 64);
    };
  }
});